/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/MenuPermissionToRoleResource', 'model/MenuPermissionsResponse', 'model/ResponseObject'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/MenuPermissionToRoleResource'), require('../model/MenuPermissionsResponse'), require('../model/ResponseObject'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.MenuPermissionApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.MenuPermissionToRoleResource, root.GisServerApis.MenuPermissionsResponse, root.GisServerApis.ResponseObject);
  }
}(this, function(ApiClient, MenuPermissionToRoleResource, MenuPermissionsResponse, ResponseObject) {
  'use strict';

  /**
   * MenuPermission service.
   * @module api/MenuPermissionApi
   * @version 1.0.0
   */

  /**
   * Constructs a new MenuPermissionApi. 
   * @alias module:api/MenuPermissionApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the addMenusToRolesV1 operation.
     * @callback module:api/MenuPermissionApi~addMenusToRolesV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add the menus to the roles.
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/MenuPermissionToRoleResource>} opts.menuPermissions A collection of menu permissions. Each item contains a menu and role ID.
     * @param {module:api/MenuPermissionApi~addMenusToRolesV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.addMenusToRolesV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['menuPermissions'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/menupermission', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getMenuPermissionsForCurrentAccountV1 operation.
     * @callback module:api/MenuPermissionApi~getMenuPermissionsForCurrentAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/MenuPermissionsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the menus for current account.
     * @param {module:api/MenuPermissionApi~getMenuPermissionsForCurrentAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MenuPermissionsResponse}
     */
    this.getMenuPermissionsForCurrentAccountV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = MenuPermissionsResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/current/menupermission', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getMenuPermissionsForRoleV1 operation.
     * @callback module:api/MenuPermissionApi~getMenuPermissionsForRoleV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/MenuPermissionsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the menus for a specified role.
     * @param {String} roleId The role ID to query
     * @param {module:api/MenuPermissionApi~getMenuPermissionsForRoleV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MenuPermissionsResponse}
     */
    this.getMenuPermissionsForRoleV1 = function(roleId, callback) {
      var postBody = null;

      // verify the required parameter 'roleId' is set
      if (roleId === undefined || roleId === null) {
        throw new Error("Missing the required parameter 'roleId' when calling getMenuPermissionsForRoleV1");
      }


      var pathParams = {
        'roleId': roleId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = MenuPermissionsResponse;

      return this.apiClient.callApi(
        '/api/v1/roles/{roleId}/menupermission', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getMenuPermissionsV1 operation.
     * @callback module:api/MenuPermissionApi~getMenuPermissionsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/MenuPermissionsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all the menus
     * @param {module:api/MenuPermissionApi~getMenuPermissionsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MenuPermissionsResponse}
     */
    this.getMenuPermissionsV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = MenuPermissionsResponse;

      return this.apiClient.callApi(
        '/api/v1/menupermission', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the removeMenusFromRoleV1 operation.
     * @callback module:api/MenuPermissionApi~removeMenusFromRoleV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove all the assigned menus from a specified role.
     * @param {String} roleId The role ID to remove the menus from.
     * @param {module:api/MenuPermissionApi~removeMenusFromRoleV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.removeMenusFromRoleV1 = function(roleId, callback) {
      var postBody = null;

      // verify the required parameter 'roleId' is set
      if (roleId === undefined || roleId === null) {
        throw new Error("Missing the required parameter 'roleId' when calling removeMenusFromRoleV1");
      }


      var pathParams = {
        'roleId': roleId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/roles/{roleId}/menupermission', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

